<div style="overflow: hidden; overflow-x: scroll; width: 100%; ">

    <div class="modal-content modal-xl">
        <div class="modal-header">
            <div class="col-md-12">
                <i (click)="cancel()" style="cursor: pointer;" data-dismiss="modal" class="fas fa-arrow-left"></i>&nbsp;
                <strong [ngStyle]="{'color': Status=='online'?'green':'red'}">Exam Assessment<span
                        *ngIf="Status=='online'">-SP:{{conn.NetSpeed}}</span></strong>
            </div>



        </div>
        <div class="row modal-body">


            <div class="col-md-12">
                <table role="table" class="table-striped table-bordered" style="width: 100%;">
                    <tbody>
                        <tr>
                            <td><strong>No. of Question</strong></td>
                            <td>
                                <strong>{{Object.NOQ}}</strong>

                            </td>
                        </tr>
                        <tr>
                            <td><strong>Total Answered</strong></td>
                            <td style="color:rgb(92, 184, 92);">
                                <strong>{{Object.Answered}}</strong>
                            </td>
                        </tr>
                        <tr>
                            <td><strong>Questions not Answered</strong></td>
                            <td>
                                <button type="button" class="btn exam-btn"
                                    style="margin-left:5px !important; cursor: none;">
                                    <strong>{{Object.NotAttend.length}}</strong>
                                </button>
                                <!-- <button type="button" class="btn exam-btn" style="margin-left:5px !important; cursor: none;"
                                *ngFor="let _qno of Object.NotAttend">
                                <strong>{{_qno.QNo}}</strong>
                            </button> -->
                            </td>
                        </tr>
                        <tr>
                            <td><strong>Mark for review</strong></td>
                            <td>
                                <span *ngIf="Object.MarkForReview.length ==0">No Question Marked for Review</span>

                                <button type="button" class="btn btn-marked-for-review"
                                    style="margin-left:5px !important;cursor: none;"
                                    *ngIf="Object.MarkForReview.length >0">
                                    <strong>{{Object.MarkForReview.length}}</strong>
                                </button>
                                <!-- <button type="button" class="btn btn-marked-for-review"
                                style="margin-left:5px !important;cursor: none;"
                                *ngFor="let _qno of Object.MarkForReview">
                                <strong>{{_qno.QNo}}</strong>
                            </button> -->

                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>


        </div>
        <div class="model-footer">
            <div class="col-md-12 text-center" *ngIf="Object.Enable_Yes_For_Submit==false">
                <p class="text-center" style="color: red;"><strong>Can't Finish the Test now. Minimum 5 minutes are
                        required.
                        Try Later.</strong></p>
                <button class="el-btn" type="button" (click)="cancel()"><strong>Close</strong></button>
            </div>
            <div class="col-md-12" style="margin-top: 15px; margin-bottom: 15px;">
                <div class="col-md-12 text-center" *ngIf="Object.Enable_Yes_For_Submit">
                    <p class="text-center"><strong>Make sure you that you have attempted all the questions before
                            proceeding
                            to submit the exam.</strong></p>
                    <p class="text-center"><strong>No changes will be allowed after submission</strong></p>
                    <hr />
                    <div class="d-flex justify-content-between" style="padding: 10px;">
                        <button class="el-btn" type="button" (click)="cancel()"><strong>Back</strong></button>
                        <button class="el-btn" type="button" (click)="Next()"><strong>Yes</strong></button>
                    </div>

                </div>
            </div>
        </div>
    </div>
</div>